import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';

import { SupportChat } from 'src/scenes/SupportChat/index.ts';

const index = true;

export const supportChatRouteObject = inferRouteObject({
  path: 'support-chat',
  Component: SupportChat.Helmet,
  children: [
    { index, element: <Navigate to='./new' replace /> },
    { path: ':convId', Component: SupportChat.Chat },
  ],
});
